import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'app/_services/report.service';

import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { DiscussionDevelopmentReportService } from './discussion-development-reports.service';
import { ProjectsService } from 'app/_services/projects.service';
const moment = require('moment');
@Component({
  selector: 'app-brands',
  templateUrl: './discussion-development-reports.component.html',
  styleUrls: ['./discussion-development-reports.component.scss']
})
export class DiscussionDevelopmentReportsComponent implements OnInit {
  projectId = "";
  typeAction = 'create';
  brandDropDownSettings: any;
  brandSelectedFilter = [];
  brandSelected = [];
  brands = [
  ];
  sourceByTopic = "";
  notSpam2 = false;
  reportName = "";
  dataReport: Object;
  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 1;
  typeReportFilter = 1;

  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  keywords = '';
  imageSrc: any;
  file: null;
  result: any;
  source_keywords = '';
  listBrands = [];
  dataList = [];
  dataTableShow = false;
  showReport = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }
  selectedDateFilter(value: any, datepicker?: any) {

    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
    this.optionsFilter = {
      locale: { format: 'DD/MM/YYYY' },
      timePicker: false,
      timePicker24Hour: true,
      timePickerSeconds: true,
      alwaysShowCalendars: false,
      maxDate: moment().subtract(1, "days").endOf('day').toDate(),
      startDate: this.daterangeFilter.start,
      endDate: this.daterangeFilter.end
    };

  }

  ckeditorContent = ``;
  public config2 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-lg'
  };
  public config1 = {
    keyboard: false,
      backdrop: 'static',
    class: 'modal-sm'
  };

  selectedProjects = [];
  recommandDiscussTopic = [];
  recommandAdd = [];

  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;
  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private brandReportService: DiscussionDevelopmentReportService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
    this.dtOptions2 = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2], 'searchable': true }
      ]
    };
  };
  resolveAfter1Seconds() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved');
      }, 1000);
    });
  }


  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }
  removeDuplicates(originalArray) {
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i]._source['topicId']] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
 }
 getRecommandPost() {
  let filter = {
    projects: this.dataReport["report_project"],
    brands: this.dataReport["report_brand"],
    gte: new Date(this.dataReport["report_start_date"]).getTime(),
    size: this.pageSizeRecommand,
    from: (this.currentPageRecommand -1) * this.pageSizeRecommand,
    lte: new Date(this.dataReport["report_end_date"]).getTime()
  };
  this.recommandDiscussTopic = [];
  this.brandReportService.getArticleTopic({ filter: filter }).subscribe(response => {
    this.totalRecommandPost = response.data.hits.total.value < (10000 - this.pageSizeRecommand) ? response.data.hits.total.value : (10000 - this.pageSizeRecommand);
    // this.recommandDiscussTopic = this.removeDuplicates(response.data.hits.hits);
    this.recommandDiscussTopic = response.data.hits.hits;

  });
 }
 showRecommentPost(modalRef) {
    // this.closeModal();
    this.getRecommandPost()
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }
  clickSaveRecommand(item) {
    let obj = {
      id: item["_source"]["id"],
      title: item["_source"]["name"],
      content: item["_source"]["content"],
      createDate: item["_source"]["createDate"]
    }
    this.recommandAdd.push(obj);
  }
  clickRemoveRecommand(item) {
    for (var i = 0; i < this.recommandAdd.length; i++) {
      if (this.recommandAdd[i]["id"] == item["_source"]["id"]) {
        this.recommandAdd.splice(i, 1);
      }
    }
  }
  checkExitsRecommand(item) {
    let check = false;
    for (var i = 0; i < this.recommandAdd.length; i++) {
      if (this.recommandAdd[i]["id"] == item["_source"]["id"]) {
        check = true;
      }
    }
    return check;
  }
  clickSaveDataReport(previewModal) {
    let content = "";
    for (var i = 0; i < this.recommandAdd.length; i++) {
      content += this.recommandAdd[i]["content"];
      if (i < (this.recommandAdd.length - 1)) {
        content += "<br>";
      }
    }
    let copy = Object.assign({}, this.dataReport);
    copy["data"]["content"] = content;
    this.dataReport = {};
    this.dataReport = Object.assign({}, copy);
    
    this.modalRef.hide();
  }
  getDataFromServer() {
    this.dataTableShow = false;
    this.brandReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    this.dataTableShow = false;

    let type = "day";
    if (this.typeReport == 2) {
      type = "week";
    } else if (this.typeReport == 3) {
      type = "month";
    } else if (this.typeReport == 4) {
      type = "year";
    } else if (this.typeReport == 5) {
      type = "option";
    }
    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      typeReport: type,
      report_code: ["DBTL"]
    };

    this.brandReportService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
      console.log(this.dataList);
    });
  }

  clickReport() {
    if (this.projectSelectedFilter.length == 0 && this.brandSelectedFilter.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    this.dataReport = {};
    this.recommandAdd = [];
    let type = "day";
    if (this.typeReportFilter == 2) {
      type = "week";
    } else if (this.typeReportFilter == 3) {
      type = "month";
    } else if (this.typeReportFilter == 4) {
      type = "year";
    } else if (this.typeReportFilter == 5) {
      type = "option";
    }
    let gte = this.daterangeFilter.start.valueOf();
    if (type == "day") {
      gte -= 6 * 24 * 60 * 60 * 1000;
    }

    // let timeRange = Math.ceil((this.daterangeFilter.end.valueOf() - this.daterangeFilter.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    let filter = {
      from: this.daterangeFilter.start.valueOf(),
      gte: gte,
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      type: type,
      sourceByTopic: this.sourceByTopic,
      notSpam: this.notSpam2
    };
    this.brandReportService.getReport({ filter: filter, index: "full" }).subscribe(response => {
      let data = response.data;
      if (data) {
        let aggregations = data.aggregations;

        let byDay = Array();
        let dataByDay = aggregations.byDay.buckets;
        for (var i = 0; i < dataByDay.length; i++) {
          let obj = {
            key: dataByDay[i].key_as_string,
            post: dataByDay[i].post.doc_count,
            comment: dataByDay[i].comment.doc_count
          }
          byDay.push(obj);
        }
        this.dataReport = {
          report_desc: "Diễn biến thảo luận",
          report_type: type,
          report_name: "Diễn biến thảo luận từ ngày " + this.daterangeFilter.start.format('DD/MM/YYYY') + " đến ngày " + this.daterangeFilter.end.format('DD/MM/YYYY'),
          report_project: this.projectSelectedFilter,
          report_brand: this.brandSelectedFilter,
          report_start_date: new Date(this.daterangeFilter.start.valueOf()),
          report_end_date: new Date(this.daterangeFilter.end.valueOf()),
          report_code: "DBTL",
          data: {
            byDay: byDay
          }
        }
      }
    });
    // console.log(filter);
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });

  }
  modalRefHide(previewModal) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(previewModal, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }
  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  clickEditReportItem(item, modalRef) {
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.ckeditorContent = this.currentConfigItem['data'].content
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });

  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.brandReportService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.modalRef.hide();
        this.modalRef2.hide();

      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    // this.closeModal();
    this.modalRef = this.modalService.show(modalRef);
  }

  async onCkEditorChange(item) {
    this.ckeditorContent = item.toString();
    this.currentConfigItem['data'].content = this.ckeditorContent;
  }

  saveEditPost() {
    if (this.currentConfigItem["data"]["content"].length == 0) {
      this.toastrService.warning("Nội dung nổi bật không được để trống!", "Thông báo");
      return;
    }
    this.brandReportService.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {

      if (res.success) {
        this.toastrService.success('Cập nhật báo cáo thành công', 'Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }

  pageChange(number) {
    this.recommandDiscussTopic = [];
    this.currentPageRecommand = number;
    this.getRecommandPost();
 }

  deleteReport() {
    this.brandReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
  }

  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/discussion-development/discussion-development-reports.component.ts